import React from 'react';
import { Svg, Path } from 'react-native-svg';

export const EmptyCartIllustration = ({ className }) => {
    return (
        <Svg
            className={className}
            width="400"
            height="400"
            viewBox="0 0 400 400"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <Path
                d="M259.95 188.953C267.644 148.162 108.747 118.175 101.026 158.971L86.8802 233.968C77.7256 282.503 236.612 312.681 245.805 263.944L259.95 188.953Z"
                fill="white"
            />
            <Path
                d="M259.95 188.953C267.644 148.162 108.747 118.175 101.026 158.971L86.8802 233.968C77.7256 282.503 236.612 312.681 245.805 263.944L259.95 188.953Z"
                fill="#FE1251"
                fillOpacity="0.25"
            />
            <Path
                d="M224.548 164.247C232.593 128.64 190.093 105.639 165.794 148.197"
                stroke="#666666"
                strokeWidth="8"
            />
            <Path
                d="M86.8806 233.968C85.8611 239.373 86.9255 244.55 89.6348 249.416C108.6 283.477 208.172 302.286 237.859 277.161C167.087 297.816 100.014 262.189 104.841 208.003C105.95 195.555 120.681 191.247 132.185 196.128C170.922 212.562 226.883 218.935 252.043 205.671C255.761 203.711 257.897 199.841 258.676 195.71L259.95 188.953C267.644 148.162 108.747 118.175 101.026 158.971L86.8806 233.968Z"
                fill="white"
            />
            <Path
                d="M86.8806 233.968C85.8611 239.373 86.9255 244.55 89.6348 249.416C108.6 283.477 208.172 302.286 237.859 277.161C167.087 297.816 100.014 262.189 104.841 208.003C105.95 195.555 120.681 191.247 132.185 196.128C170.922 212.562 226.883 218.935 252.043 205.671C255.761 203.711 257.897 199.841 258.676 195.71L259.95 188.953C267.644 148.162 108.747 118.175 101.026 158.971L86.8806 233.968Z"
                fill="#FE1251"
                fillOpacity="0.4"
            />
            <Path
                d="M185.765 229.736C164.569 263.53 127.113 248.439 127.113 213.99"
                stroke="#333333"
                strokeWidth="8"
                strokeLinecap="round"
            />
            <Path
                d="M260.185 187.12C262.89 147.387 109.487 118.947 101.093 158.637C101.233 196.934 252.362 228.364 260.059 187.554C260.101 187.409 260.143 187.264 260.185 187.12Z"
                fill="#999999"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M101.093 158.637C109.487 118.947 262.89 147.387 260.185 187.12C260.143 187.264 260.101 187.409 260.059 187.554C257.761 199.737 242.68 205.482 222.649 206.528C229.288 199.132 229.667 188.808 219.873 175.813C219.747 175.63 219.62 175.447 219.494 175.264C190.24 140.12 120.812 138.817 101.206 160.406C101.133 159.818 101.095 159.229 101.093 158.637Z"
                fill="#666666"
            />
            <Path
                d="M265.437 114.046L257.108 144.731C255.759 149.701 261.896 153.219 265.502 149.543L290.234 124.333C292.822 121.695 291.753 117.259 288.248 116.089L271.846 110.614C269.12 109.704 266.19 111.273 265.437 114.046Z"
                fill="#FE1251"
            />
            <Path
                d="M304.048 143.03L280.539 160.585C276.442 163.644 279.036 170.153 284.114 169.557L312.912 166.173C316.132 165.795 318.146 162.497 317.013 159.459L311.724 145.288C310.558 142.164 306.72 141.035 304.048 143.03Z"
                fill="#FE1251"
            />
        </Svg>
    );
};
